module.exports = __webpack_public_path__ + "img/ava.55d0799d.png";